export default function ServiceValueData() {
  return [
    {
      iconName: "m_rule",
      title: "Choice",
      description: "Choose from a variety of quality term life coverage options that best fit your needs and lifestyle."
    },
    {
      iconName: "m_bookmarkCheck",
      title: "Ease",
      description: "Our user-friendly platform simplifies the term life insurance purchasing process, guiding you through every step."
    },
    {
      iconName: "m_accountBalanceWallet",
      title: "Affordability",
      description: "Term life insurance is designed to be budget-friendly and provide essential coverage without breaking the bank."
    },
    {
      iconName: "m_avgPace",
      title: "Speed",
      description: "Get quotes and secure your coverage quickly through our streamlined process."
    },
  ]
}